import isEmpty from 'lodash-es/isEmpty';
import isObject from 'lodash-es/isObject';

export const customInputValueRender = (value: unknown): string => {
  if (value === null) {
    return '';
  }

  if (isObject(value)) {
    if (isEmpty(value)) {
      if (Array.isArray(value)) {
        return '[]';
      }
      if (value !== null) {
        return '{}';
      }
    }
  }

  return value.toString();
};
